import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-484d88e4"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  id: "homeListTitle"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_ArrowRight = _resolveComponent("ArrowRight");

  var _component_el_icon = _resolveComponent("el-icon");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: "commend-title",
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return _ctx.titleClick(_ctx.routerPath);
    })
  }, [_createElementVNode("span", null, _toDisplayString(_ctx.title), 1
  /* TEXT */
  ), _createVNode(_component_el_icon, {
    size: 15
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_ArrowRight)];
    }),
    _: 1
    /* STABLE */

  })])]);
}